// extracted by mini-css-extract-plugin
export default {"root":"OptionItem_root__4uslI","icon":"OptionItem_icon__7hBuE"};